import { HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { UserSettingControllerService } from '@api/core';
import { tapResponse } from '@ngrx/operators';
import { patchState, signalStoreFeature, type, withMethods, withProps, withState } from '@ngrx/signals';
import { rxMethod } from '@ngrx/signals/rxjs-interop';
import { NotificationService } from '@shared/services/notifications/notifications.service';
import { pipe, switchMap } from 'rxjs';
import { LPS_ORDER_SETTINGS, toLpsOrder } from '@shared-modules/user-settings/store/shared-user-settings.utils';
import { httpErrorStatusCodes } from '@stillmandigital/common';

type OrderIndex = number;

export type LpsOrderMap = { [lpId: number]: OrderIndex };

export const useUserSettings = () =>
  signalStoreFeature(
    {
      props: {
        _notificationService: type<NotificationService>(),
      },
    },
    withState({
      lpsOrder: {} as LpsOrderMap,
      lpsOrderLoaded: false,
    }),
    withProps(() => ({
      _settingsService: inject(UserSettingControllerService),
    })),
    withMethods(store => {
      const loadLpsOrder = rxMethod<void>(
        pipe(
          switchMap(() =>
            store._settingsService.getSettingByKey({ key: LPS_ORDER_SETTINGS }).pipe(
              tapResponse({
                next: setting => patchState(store, { lpsOrder: toLpsOrder(setting), lpsOrderLoaded: true }),
                error: (error: HttpErrorResponse) => {
                  if (error.status === httpErrorStatusCodes.notFound) {
                    patchState(store, { lpsOrder: toLpsOrder() });
                  } else {
                    store._notificationService.showErrorNotification('Failed to load LPS order', error);
                  }
                  patchState(store, { lpsOrderLoaded: true });
                },
              }),
            ),
          ),
        ),
      );

      return {
        loadLpsOrder,
      };
    }),
  );
